const ctx = require.context('./modules', true, /\.js$/)

let api = {}
for (const key of ctx.keys()) {
  api = Object.assign(api, ctx(key).default)
}

module.exports = api
